export default __webpack_public_path__ + "static/media/Image From ET__UIww.e56ecde7.png";